module.exports = [
    'proccessing the answers ... ',
    'there are not enough signs of autism',
    'based on your answers, there is a possibility of autism',
    'You can contact your chosen institution for further evaluation',
    'based on your answers, there is high probablity of autism',
    'For further evalutation, visit a pediatric subspecialty or an autism center ',
    'return to homepage'
]